// Round 4-E: Skeleton scaffolding so a slow Reports load shows shape
// instead of a single grey "Loading…" line. Each block is a pulsing
// rounded rectangle sized to roughly match the card it'll replace.
export function SkeletonLine({ w = '100%', h = 14, mb = 8 }) {
  return <div style={{
    width: w, height: h, borderRadius: 6, marginBottom: mb,
    background: 'linear-gradient(90deg, #eceff1 0%, #f5f7f8 50%, #eceff1 100%)',
    backgroundSize: '200% 100%',
    animation: 'empireSkeleton 1.4s ease-in-out infinite',
  }} />;
}
